import { render, staticRenderFns } from "./ProductDescriptionCard.vue?vue&type=template&id=5de1c488&"
import script from "./ProductDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports